var _style, _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudentandInstructor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F0915A;}\r\n\t.st1{fill:#5055A5;}\r\n\t.st2{fill:#FAB991;}\r\n\t.st3{fill:#5F7DBE;}\r\n\t.st4{fill:#FFC33C;}\r\n\t.st5{fill:#464646;}\r\n\t.st6{fill:#AAC3D7;}\r\n\t.st7{fill:#D7E6F0;}\r\n\t.st8{fill:#323232;}\r\n\t.st9{fill:#8CAAC8;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96,104c-4.4,0-8-3.6-8-8v-8c0-4.4,3.6-8,8-8V104z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96,104L96,104V80l0,0c-4.4,0-8,3.6-8,8v8C88,100.4,91.6,104,96,104z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160,80c4.4,0,8,3.6,8,8v8c0,4.4-3.6,8-8,8V80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160,104L160,104V80l0,0c4.4,0,8,3.6,8,8v8C168,100.4,164.4,104,160,104z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352,104c-4.4,0-8-3.6-8-8v-8c0-4.4,3.6-8,8-8V104z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352,104L352,104V80l0,0c-4.4,0-8,3.6-8,8v8C344,100.4,347.6,104,352,104z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416,80c4.4,0,8,3.6,8,8v8c0,4.4-3.6,8-8,8V80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416,104L416,104V80l0,0c4.4,0,8,3.6,8,8v8C424,100.4,420.4,104,416,104z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208,464c-13.9,0-26.5-9.3-30.6-22.7l-39.9-130.7c-2.5-8.2-1.7-16.8,2.3-24.3c4-7.6,10.8-13.1,19-15.6 c3-0.9,6.2-1.4,9.4-1.4c13.9,0,26.5,9.3,30.5,22.7l39.9,130.7c2.5,8.2,1.7,16.8-2.3,24.3c-4,7.6-10.8,13.1-19,15.6 C214.4,463.5,211.3,464,208,464z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208,464c-13.7,0-26.4-8.9-30.6-22.7l-39.9-130.7c-5.2-16.9,4.4-34.8,21.3-39.9 c16.9-5.2,34.8,4.4,39.9,21.3l39.9,130.7c5.2,16.9-4.4,34.8-21.3,39.9C214.2,463.6,211.1,464,208,464z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48,464c-3,0-6.1-0.5-9.3-1.4c-16.8-5.2-26.4-23.1-21.3-39.9l40-131.1c4.2-13.6,16.5-22.7,30.6-22.7 c3.1,0,6.3,0.5,9.3,1.4c16.8,5.2,26.4,23.1,21.3,39.9l-40,131.1C74.5,454.7,61.9,464,48,464z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48,464c-3.1,0-6.2-0.5-9.3-1.4c-16.9-5.2-26.4-23-21.3-39.9l40-131.1c5.2-16.9,23-26.4,39.9-21.3 c16.9,5.2,26.4,23,21.3,39.9l-40,131.1C74.4,455.1,61.7,464,48,464z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112,128c-8.8,0-16-7.2-16-16V64c0-8.8,7.2-16,16-16h32c8.8,0,16,7.2,16,16v48c0,8.8-7.2,16-16,16H112z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M144,128h-32c-8.8,0-16-7.2-16-16V64c0-8.8,7.2-16,16-16h32c8.8,0,16,7.2,16,16v48 C160,120.8,152.8,128,144,128z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 128,
    className: "st3",
    width: 128,
    height: 146.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 128,
    className: "st3",
    width: 128,
    height: 146.7
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192,192c-4.4,0-8-3.6-8-8v-48c0-4.4,3.6-8,8-8h24c4.4,0,8,3.6,8,8v48c0,4.4-3.6,8-8,8H192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216,192h-24c-4.4,0-8-3.6-8-8v-48c0-4.4,3.6-8,8-8h24c4.4,0,8,3.6,8,8v48C224,188.4,220.4,192,216,192z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "112,128 144,128 128,160  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "128,160 112,128 144,128  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32,224v-64c0-17.6,14.4-32,32-32v96H32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32,224h32v-96l0,0c-17.7,0-32,14.3-32,32V224z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M184,160v-24c0-4.4,3.6-8,8-8h24c4.4,0,8,3.6,8,8v16c0,4.4-3.6,8-8,8H184z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M216,160h-32v-24c0-4.4,3.6-8,8-8h24c4.4,0,8,3.6,8,8v16C224,156.4,220.4,160,216,160z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192,168c-4.4,0-8-3.6-8-8h21.3c0,4.5-3.5,8-8,8H192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.3,168H192c-4.4,0-8-3.6-8-8l0,0h21.3l0,0C205.3,164.4,201.8,168,197.3,168z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32,248c-4.4,0-8-3.6-8-8v-24h32c4.4,0,8,3.6,8,8v16c0,4.4-3.6,8-8,8H32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56,216H24v24c0,4.4,3.6,8,8,8h24c4.4,0,8-3.6,8-8v-16C64,219.6,60.4,216,56,216z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,216c0-4.4,3.6-8,8-8h5.3c4.5,0,8,3.5,8,8l0,0H24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.3,208H32c-4.4,0-8,3.6-8,8l0,0h21.3l0,0C45.3,211.6,41.8,208,37.3,208z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24,464c-4.4,0-8-3.6-8-8c0-17.6,14.4-32,32-32s32,14.4,32,32c0,4.4-3.6,8-8,8H24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48,424L48,424c-17.7,0-32,14.3-32,32l0,0c0,4.4,3.6,8,8,8h48c4.4,0,8-3.6,8-8l0,0 C80,438.3,65.7,424,48,424z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M184,464c-4.4,0-8-3.6-8-8c0-17.6,14.4-32,32-32s32,14.4,32,32c0,4.4-3.6,8-8,8H184z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M208,424L208,424c-17.7,0-32,14.3-32,32l0,0c0,4.4,3.6,8,8,8h48c4.4,0,8-3.6,8-8l0,0 C240,438.3,225.7,424,208,424z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.2,320c-5.2,0-10-2.4-13-6.7c-3-4.2-3.8-9.5-2.2-14.4l7.2-21.4c1.1-3.3,4.1-5.5,7.6-5.6h132.4 c3.5,0,6.5,2.2,7.6,5.5l7.2,21.5c1.6,5,0.8,10.3-2.3,14.5c-3,4.2-7.8,6.6-12.9,6.6H62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.2,277.5L47,298.9c-3.5,10.4,4.3,21.1,15.2,21.1h131.6c10.9,0,18.6-10.7,15.2-21.1l-7.2-21.5 c-1.1-3.3-4.1-5.5-7.6-5.5H61.8C58.3,272,55.3,274.2,54.2,277.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "80,256 144,128 160,128 96,256  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "96,256 160,128 144,128 80,256  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "96,128 112,128 128,160 120,176  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "128,160 112,128 96,128 120,176  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 248,
    className: "st4",
    width: 128,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 248,
    className: "st4",
    width: 128,
    height: 24
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M464,464c-13.9,0-26.5-9.3-30.6-22.7l-39.9-130.7c-2.5-8.2-1.7-16.8,2.3-24.3c4-7.6,10.8-13.1,19-15.6 c3-0.9,6.2-1.4,9.4-1.4c13.9,0,26.5,9.3,30.5,22.7l39.9,130.7c2.5,8.2,1.7,16.8-2.3,24.3c-4,7.6-10.8,13.1-19,15.6 C470.4,463.5,467.3,464,464,464z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M464,464c-13.7,0-26.4-8.9-30.6-22.7l-39.9-130.7c-5.2-16.9,4.4-34.8,21.3-39.9 c16.9-5.2,34.8,4.4,39.9,21.3l39.9,130.7c5.2,16.9-4.4,34.8-21.3,39.9C470.2,463.6,467.1,464,464,464z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304,464c-3,0-6.1-0.5-9.3-1.4c-16.8-5.2-26.4-23.1-21.3-39.9l40-131.1c4.2-13.6,16.5-22.7,30.6-22.7 c3.1,0,6.3,0.5,9.3,1.4c16.8,5.2,26.4,23.1,21.3,39.9l-40,131.1C330.5,454.7,317.9,464,304,464z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304,464c-3.1,0-6.2-0.5-9.3-1.4c-16.9-5.2-26.4-23-21.3-39.9l40-131.1c5.2-16.9,23-26.4,39.9-21.3 c16.9,5.2,26.4,23,21.3,39.9l-40,131.1C330.4,455.1,317.7,464,304,464z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 128,
    className: "st3",
    width: 128,
    height: 146.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 128,
    className: "st3",
    width: 128,
    height: 146.7
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M448,192c-4.4,0-8-3.6-8-8v-48c0-4.4,3.6-8,8-8h24c4.4,0,8,3.6,8,8v48c0,4.4-3.6,8-8,8H448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472,192h-24c-4.4,0-8-3.6-8-8v-48c0-4.4,3.6-8,8-8h24c4.4,0,8,3.6,8,8v48C480,188.4,476.4,192,472,192z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "368,128 400,128 384,160  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "384,160 368,128 400,128  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288,224v-64c0-17.6,14.4-32,32-32v96H288z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288,224h32v-96l0,0c-17.7,0-32,14.3-32,32V224z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M440,160v-24c0-4.4,3.6-8,8-8h24c4.4,0,8,3.6,8,8v16c0,4.4-3.6,8-8,8H440z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M472,160h-32v-24c0-4.4,3.6-8,8-8h24c4.4,0,8,3.6,8,8v16C480,156.4,476.4,160,472,160z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448,168c-4.4,0-8-3.6-8-8h21.3c0,4.5-3.5,8-8,8H448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.3,168H448c-4.4,0-8-3.6-8-8l0,0h21.3l0,0C461.3,164.4,457.8,168,453.3,168z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M280,464c-4.4,0-8-3.6-8-8c0-17.6,14.4-32,32-32s32,14.4,32,32c0,4.4-3.6,8-8,8H280z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M304,424L304,424c-17.7,0-32,14.3-32,32l0,0c0,4.4,3.6,8,8,8h48c4.4,0,8-3.6,8-8l0,0 C336,438.3,321.7,424,304,424z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M440,464c-4.4,0-8-3.6-8-8c0-17.6,14.4-32,32-32s32,14.4,32,32c0,4.4-3.6,8-8,8H440z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M464,424L464,424c-17.7,0-32,14.3-32,32l0,0c0,4.4,3.6,8,8,8h48c4.4,0,8-3.6,8-8l0,0 C496,438.3,481.7,424,464,424z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M318.2,320.1c-5.2,0-10-2.4-13-6.7c-3-4.2-3.8-9.5-2.2-14.4l7.2-21.5c1.1-3.3,4.1-5.5,7.6-5.5h132.4 c3.5,0,6.5,2.2,7.6,5.5L465,299c1.6,5,0.8,10.3-2.3,14.5c-3,4.2-7.8,6.6-12.9,6.6H318.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M310.2,277.5L303,299c-3.5,10.4,4.3,21.1,15.2,21.1h131.6c10.9,0,18.6-10.7,15.2-21.1l-7.2-21.5 c-1.1-3.3-4.1-5.5-7.6-5.5H317.8C314.3,272,311.3,274.2,310.2,277.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336,256 400,128 416,128 352,256  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "352,256 416,128 400,128 336,256  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "352,128 368,128 384,160 376,176  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "384,160 368,128 352,128 376,176  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 248,
    className: "st4",
    width: 128,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 248,
    className: "st4",
    width: 128,
    height: 24
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M160,88c-4.4,0-8-3.6-8-8v-8c0-4.4-3.6-8-8-8h-32c-4.4,0-8,3.6-8,8v8c0,4.4-3.6,8-8,8V64 c0-8.8,7.2-16,16-16h32c8.8,0,16,7.2,16,16V88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M96,88L96,88c4.4,0,8-3.6,8-8v-8c0-4.4,3.6-8,8-8h32c4.4,0,8,3.6,8,8v8c0,4.4,3.6,8,8,8l0,0V64 c0-8.8-7.2-16-16-16h-32c-8.8,0-16,7.2-16,16V88z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M368,128c-8.8,0-16-7.2-16-16V64c0-8.8,7.2-16,16-16h32c8.8,0,16,7.2,16,16v48c0,8.8-7.2,16-16,16H368z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M400,128h-32c-8.8,0-16-7.2-16-16V64c0-8.8,7.2-16,16-16h32c8.8,0,16,7.2,16,16v48 C416,120.8,408.8,128,400,128z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M416,88c-4.4,0-8-3.6-8-8v-8c0-4.4-3.6-8-8-8h-32c-4.4,0-8,3.6-8,8v8c0,4.4-3.6,8-8,8V64 c0-8.8,7.2-16,16-16h32c8.8,0,16,7.2,16,16V88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M352,88L352,88c4.4,0,8-3.6,8-8v-8c0-4.4,3.6-8,8-8h32c4.4,0,8,3.6,8,8v8c0,4.4,3.6,8,8,8l0,0V64 c0-8.8-7.2-16-16-16h-32c-8.8,0-16,7.2-16,16V88z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M288,248c-4.4,0-8-3.6-8-8v-24h32c4.4,0,8,3.6,8,8v16c0,4.4-3.6,8-8,8H288z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M312,216h-32v24c0,4.4,3.6,8,8,8h24c4.4,0,8-3.6,8-8v-16C320,219.6,316.4,216,312,216z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280,216c0-4.4,3.6-8,8-8h5.3c4.5,0,8,3.5,8,8l0,0H280z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.3,208H288c-4.4,0-8,3.6-8,8l0,0h21.3l0,0C301.3,211.6,297.8,208,293.3,208z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96,104c-4.4,0-8-3.6-8-8v-8c0-4.4,3.6-8,8-8V104z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96,104L96,104V80l0,0c-4.4,0-8,3.6-8,8v8C88,100.4,91.6,104,96,104z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160,80c4.4,0,8,3.6,8,8v8c0,4.4-3.6,8-8,8V80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160,104L160,104V80l0,0c4.4,0,8,3.6,8,8v8C168,100.4,164.4,104,160,104z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352,104c-4.4,0-8-3.6-8-8v-8c0-4.4,3.6-8,8-8V104z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352,104L352,104V80l0,0c-4.4,0-8,3.6-8,8v8C344,100.4,347.6,104,352,104z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416,80c4.4,0,8,3.6,8,8v8c0,4.4-3.6,8-8,8V80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416,104L416,104V80l0,0c4.4,0,8,3.6,8,8v8C424,100.4,420.4,104,416,104z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208,464c-13.9,0-26.5-9.3-30.6-22.7l-39.9-130.7c-2.5-8.2-1.7-16.8,2.3-24.3c4-7.6,10.8-13.1,19-15.6 c3-0.9,6.2-1.4,9.4-1.4c13.9,0,26.5,9.3,30.5,22.7l39.9,130.7c2.5,8.2,1.7,16.8-2.3,24.3c-4,7.6-10.8,13.1-19,15.6 C214.4,463.5,211.3,464,208,464z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208,464c-13.7,0-26.4-8.9-30.6-22.7l-39.9-130.7c-5.2-16.9,4.4-34.8,21.3-39.9 c16.9-5.2,34.8,4.4,39.9,21.3l39.9,130.7c5.2,16.9-4.4,34.8-21.3,39.9C214.2,463.6,211.1,464,208,464z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M48,464c-3,0-6.1-0.5-9.3-1.4c-16.8-5.2-26.4-23.1-21.3-39.9l40-131.1c4.2-13.6,16.5-22.7,30.6-22.7 c3.1,0,6.3,0.5,9.3,1.4c16.8,5.2,26.4,23.1,21.3,39.9l-40,131.1C74.5,454.7,61.9,464,48,464z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M48,464c-3.1,0-6.2-0.5-9.3-1.4c-16.9-5.2-26.4-23-21.3-39.9l40-131.1c5.2-16.9,23-26.4,39.9-21.3 c16.9,5.2,26.4,23,21.3,39.9l-40,131.1C74.4,455.1,61.7,464,48,464z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112,128c-8.8,0-16-7.2-16-16V64c0-8.8,7.2-16,16-16h32c8.8,0,16,7.2,16,16v48c0,8.8-7.2,16-16,16H112z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M144,128h-32c-8.8,0-16-7.2-16-16V64c0-8.8,7.2-16,16-16h32c8.8,0,16,7.2,16,16v48 C160,120.8,152.8,128,144,128z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 128,
    className: "st7",
    width: 128,
    height: 146.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 128,
    className: "st7",
    width: 128,
    height: 146.7
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M192,192c-4.4,0-8-3.6-8-8v-48c0-4.4,3.6-8,8-8h24c4.4,0,8,3.6,8,8v48c0,4.4-3.6,8-8,8H192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216,192h-24c-4.4,0-8-3.6-8-8v-48c0-4.4,3.6-8,8-8h24c4.4,0,8,3.6,8,8v48C224,188.4,220.4,192,216,192z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "112,128 144,128 128,160  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "128,160 112,128 144,128  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M32,224v-64c0-17.6,14.4-32,32-32v96H32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M32,224h32v-96l0,0c-17.7,0-32,14.3-32,32V224z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M184,160v-24c0-4.4,3.6-8,8-8h24c4.4,0,8,3.6,8,8v16c0,4.4-3.6,8-8,8H184z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M216,160h-32v-24c0-4.4,3.6-8,8-8h24c4.4,0,8,3.6,8,8v16C224,156.4,220.4,160,216,160z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192,168c-4.4,0-8-3.6-8-8h21.3c0,4.5-3.5,8-8,8H192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.3,168H192c-4.4,0-8-3.6-8-8l0,0h21.3l0,0C205.3,164.4,201.8,168,197.3,168z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32,248c-4.4,0-8-3.6-8-8v-24h32c4.4,0,8,3.6,8,8v16c0,4.4-3.6,8-8,8H32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56,216H24v24c0,4.4,3.6,8,8,8h24c4.4,0,8-3.6,8-8v-16C64,219.6,60.4,216,56,216z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,216c0-4.4,3.6-8,8-8h5.3c4.5,0,8,3.5,8,8l0,0H24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.3,208H32c-4.4,0-8,3.6-8,8l0,0h21.3l0,0C45.3,211.6,41.8,208,37.3,208z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24,464c-4.4,0-8-3.6-8-8c0-17.6,14.4-32,32-32s32,14.4,32,32c0,4.4-3.6,8-8,8H24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48,424L48,424c-17.7,0-32,14.3-32,32l0,0c0,4.4,3.6,8,8,8h48c4.4,0,8-3.6,8-8l0,0 C80,438.3,65.7,424,48,424z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M184,464c-4.4,0-8-3.6-8-8c0-17.6,14.4-32,32-32s32,14.4,32,32c0,4.4-3.6,8-8,8H184z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M208,424L208,424c-17.7,0-32,14.3-32,32l0,0c0,4.4,3.6,8,8,8h48c4.4,0,8-3.6,8-8l0,0 C240,438.3,225.7,424,208,424z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M62.2,320c-5.2,0-10-2.4-13-6.7c-3-4.2-3.8-9.5-2.2-14.4l7.2-21.4c1.1-3.3,4.1-5.5,7.6-5.6h132.4 c3.5,0,6.5,2.2,7.6,5.5l7.2,21.5c1.6,5,0.8,10.3-2.3,14.5c-3,4.2-7.8,6.6-12.9,6.6H62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M54.2,277.5L47,298.9c-3.5,10.4,4.3,21.1,15.2,21.1h131.6c10.9,0,18.6-10.7,15.2-21.1l-7.2-21.5 c-1.1-3.3-4.1-5.5-7.6-5.5H61.8C58.3,272,55.3,274.2,54.2,277.5z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "84,248 144,128 160,128 100,248  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "100,248 160,128 144,128 84,248  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "96,128 112,128 128,160 120,176  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "128,160 112,128 96,128 120,176  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M464,464c-13.9,0-26.5-9.3-30.6-22.7l-39.9-130.7c-2.5-8.2-1.7-16.8,2.3-24.3c4-7.6,10.8-13.1,19-15.6 c3-0.9,6.2-1.4,9.4-1.4c13.9,0,26.5,9.3,30.5,22.7l39.9,130.7c2.5,8.2,1.7,16.8-2.3,24.3c-4,7.6-10.8,13.1-19,15.6 C470.4,463.5,467.3,464,464,464z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M464,464c-13.7,0-26.4-8.9-30.6-22.7l-39.9-130.7c-5.2-16.9,4.4-34.8,21.3-39.9 c16.9-5.2,34.8,4.4,39.9,21.3l39.9,130.7c5.2,16.9-4.4,34.8-21.3,39.9C470.2,463.6,467.1,464,464,464z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M304,464c-3,0-6.1-0.5-9.3-1.4c-16.8-5.2-26.4-23.1-21.3-39.9l40-131.1c4.2-13.6,16.5-22.7,30.6-22.7 c3.1,0,6.3,0.5,9.3,1.4c16.8,5.2,26.4,23.1,21.3,39.9l-40,131.1C330.5,454.7,317.9,464,304,464z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M304,464c-3.1,0-6.2-0.5-9.3-1.4c-16.9-5.2-26.4-23-21.3-39.9l40-131.1c5.2-16.9,23-26.4,39.9-21.3 c16.9,5.2,26.4,23,21.3,39.9l-40,131.1C330.4,455.1,317.7,464,304,464z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 128,
    className: "st7",
    width: 128,
    height: 146.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 128,
    className: "st7",
    width: 128,
    height: 146.7
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M448,192c-4.4,0-8-3.6-8-8v-48c0-4.4,3.6-8,8-8h24c4.4,0,8,3.6,8,8v48c0,4.4-3.6,8-8,8H448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M472,192h-24c-4.4,0-8-3.6-8-8v-48c0-4.4,3.6-8,8-8h24c4.4,0,8,3.6,8,8v48C480,188.4,476.4,192,472,192z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "368,128 400,128 384,160  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "384,160 368,128 400,128  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M288,224v-64c0-17.6,14.4-32,32-32v96H288z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M288,224h32v-96l0,0c-17.7,0-32,14.3-32,32V224z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M440,160v-24c0-4.4,3.6-8,8-8h24c4.4,0,8,3.6,8,8v16c0,4.4-3.6,8-8,8H440z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M472,160h-32v-24c0-4.4,3.6-8,8-8h24c4.4,0,8,3.6,8,8v16C480,156.4,476.4,160,472,160z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448,168c-4.4,0-8-3.6-8-8h21.3c0,4.5-3.5,8-8,8H448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.3,168H448c-4.4,0-8-3.6-8-8l0,0h21.3l0,0C461.3,164.4,457.8,168,453.3,168z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M280,464c-4.4,0-8-3.6-8-8c0-17.6,14.4-32,32-32s32,14.4,32,32c0,4.4-3.6,8-8,8H280z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M304,424L304,424c-17.7,0-32,14.3-32,32l0,0c0,4.4,3.6,8,8,8h48c4.4,0,8-3.6,8-8l0,0 C336,438.3,321.7,424,304,424z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M440,464c-4.4,0-8-3.6-8-8c0-17.6,14.4-32,32-32s32,14.4,32,32c0,4.4-3.6,8-8,8H440z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M464,424L464,424c-17.7,0-32,14.3-32,32l0,0c0,4.4,3.6,8,8,8h48c4.4,0,8-3.6,8-8l0,0 C496,438.3,481.7,424,464,424z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M318.2,320.1c-5.2,0-10-2.4-13-6.7c-3-4.2-3.8-9.5-2.2-14.4l7.2-21.5c1.1-3.3,4.1-5.5,7.6-5.5h132.4 c3.5,0,6.5,2.2,7.6,5.5L465,299c1.6,5,0.8,10.3-2.3,14.5c-3,4.2-7.8,6.6-12.9,6.6H318.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M310.2,277.5L303,299c-3.5,10.4,4.3,21.1,15.2,21.1h131.6c10.9,0,18.6-10.7,15.2-21.1l-7.2-21.5 c-1.1-3.3-4.1-5.5-7.6-5.5H317.8C314.3,272,311.3,274.2,310.2,277.5z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "340,248 400,128 416,128 356,248  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "356,248 416,128 400,128 340,248  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "352,128 368,128 384,160 376,176  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "384,160 368,128 352,128 376,176  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M160,88c-4.4,0-8-3.6-8-8v-8c0-4.4-3.6-8-8-8h-32c-4.4,0-8,3.6-8,8v8c0,4.4-3.6,8-8,8V64 c0-8.8,7.2-16,16-16h32c8.8,0,16,7.2,16,16V88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M96,88L96,88c4.4,0,8-3.6,8-8v-8c0-4.4,3.6-8,8-8h32c4.4,0,8,3.6,8,8v8c0,4.4,3.6,8,8,8l0,0V64 c0-8.8-7.2-16-16-16h-32c-8.8,0-16,7.2-16,16V88z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M368,128c-8.8,0-16-7.2-16-16V64c0-8.8,7.2-16,16-16h32c8.8,0,16,7.2,16,16v48c0,8.8-7.2,16-16,16H368z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M400,128h-32c-8.8,0-16-7.2-16-16V64c0-8.8,7.2-16,16-16h32c8.8,0,16,7.2,16,16v48 C416,120.8,408.8,128,400,128z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M416,88c-4.4,0-8-3.6-8-8v-8c0-4.4-3.6-8-8-8h-32c-4.4,0-8,3.6-8,8v8c0,4.4-3.6,8-8,8V64 c0-8.8,7.2-16,16-16h32c8.8,0,16,7.2,16,16V88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M352,88L352,88c4.4,0,8-3.6,8-8v-8c0-4.4,3.6-8,8-8h32c4.4,0,8,3.6,8,8v8c0,4.4,3.6,8,8,8l0,0V64 c0-8.8-7.2-16-16-16h-32c-8.8,0-16,7.2-16,16V88z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M288,248c-4.4,0-8-3.6-8-8v-24h32c4.4,0,8,3.6,8,8v16c0,4.4-3.6,8-8,8H288z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M312,216h-32v24c0,4.4,3.6,8,8,8h24c4.4,0,8-3.6,8-8v-16C320,219.6,316.4,216,312,216z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280,216c0-4.4,3.6-8,8-8h5.3c4.5,0,8,3.5,8,8l0,0H280z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.3,208H288c-4.4,0-8,3.6-8,8l0,0h21.3l0,0C301.3,211.6,297.8,208,293.3,208z"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M154.7,303.6c-1.6,0-3.1-0.7-4.3-2L128,276l-22.4,25.6c-1.1,1.2-2.7,1.9-4.3,1.9c-1.4,0-2.8-0.5-3.9-1.5 l-8.7-8c-2.4-2.3-2.6-6-0.4-8.5l11.8-13.5H64v-24h128v24h-36l11.7,13.5c2.1,2.5,1.9,6.3-0.4,8.5l-8.7,8 C157.5,303,156.1,303.6,154.7,303.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M192,248H64v24h36.1l-11.8,13.5c-2.2,2.5-2,6.2,0.4,8.5l8.7,8c2.4,2.2,6,2,8.2-0.4L128,276l22.4,25.6 c2.2,2.5,5.8,2.6,8.2,0.4l8.7-8c2.4-2.2,2.5-6,0.4-8.5L156,272h36V248z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M122.2,271.3l-11.6-11.6l11.6-11.6h11.6l11.6,11.6c-2.9,2.9-5,5-7.4,7.4c-1.3,1.3-2.6,2.6-4.2,4.2l0,0H122.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M133.8,271.3h-11.6c-4.5-4.5-7.1-7.1-11.6-11.6l0,0c4.5-4.5,7.1-7.1,11.6-11.6h11.6c4.5,4.5,7.1,7.1,11.6,11.6 l0,0C140.9,264.1,138.3,266.8,133.8,271.3z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M410.7,303.6c-1.6,0-3.1-0.7-4.3-2L384,276l-22.4,25.6c-1.1,1.2-2.7,1.9-4.3,1.9c-1.4,0-2.8-0.5-3.9-1.5 l-8.7-8c-2.4-2.3-2.6-6-0.4-8.5l11.8-13.5H320v-24h128v24h-36l11.7,13.5c2.1,2.5,1.9,6.3-0.4,8.5l-8.7,8 C413.5,303,412.1,303.6,410.7,303.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M448,248H320v24h36.1l-11.8,13.5c-2.2,2.5-2,6.2,0.4,8.5l8.7,8c2.4,2.2,6,2,8.2-0.4L384,276l22.4,25.6 c2.2,2.5,5.8,2.6,8.2,0.4l8.7-8c2.4-2.2,2.5-6,0.4-8.5L412,272h36V248z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M378.2,271.3l-11.6-11.6l11.6-11.6h11.6l11.6,11.6c-2.9,2.9-5,5-7.4,7.4c-1.3,1.3-2.6,2.6-4.2,4.2l0,0H378.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M389.8,271.3h-11.6c-4.5-4.5-7.1-7.1-11.6-11.6l0,0c4.5-4.5,7.1-7.1,11.6-11.6h11.6c4.5,4.5,7.1,7.1,11.6,11.6 l0,0C396.9,264.1,394.3,266.8,389.8,271.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentandInstructor);
export default __webpack_public_path__ + "static/media/Student and Instructor.75a4b6c57d338f541c43b7d10a2b36f4.svg";
export { ForwardRef as ReactComponent };